import {CAUI} from './ca-ui';
import {Component} from './component';
import {ControlButton} from './control-button';
import {ControlButtonContainer} from './control-button-container';
import * as pdfjsViewer from 'pdfjs-dist/web/pdf_viewer';
import * as pdfjsLib from 'pdfjs-dist/build/pdf';
import {LoadSpinner} from './load-spinner';

export class PDFView extends Component {
    static defaultOptions = {
        componentName: 'PDFView',
        url: null,
        workerSrc: '//cdn.jsdelivr.net/npm/pdfjs-dist@2.9.359/build/pdf.worker.js'
    };

    constructor(options) {
        super($.extend({}, PDFView.defaultOptions, options));

        console.log(this.options);

        this.zoommed = false;
        this.isPlayingTts = false;

        // Load spinner
        this.loadSpinner = new LoadSpinner({});
        this.add(this.loadSpinner);

        this.loadSpinner.show();

        this.controlsContainer = new ControlButtonContainer({});
        this.add(this.controlsContainer);

        // Zoom
        this.zoomControlGroup = $('<div class="ca-ui_control-group"></div>');
        this.zoomControlGroup.hide();
        this.controlsContainer.add(this.zoomControlGroup);

        this.zoomInControl = new ControlButton({icon: 'search-plus', tooltip: 'Zoom in', enabled: false});
        this.zoomControlGroup.append(this.zoomInControl.el);

        this.zoomOutControl = new ControlButton({icon: 'search-minus', tooltip: 'Zoom out', enabled: false});
        this.zoomControlGroup.append(this.zoomOutControl.el);

        this.zoomInControl.on('click touchstart', function () {
            this.toggleZoom();
        }.bind(this));

        this.zoomOutControl.on('click touchstart', function () {
            this.toggleZoom();
        }.bind(this));

        // Fullscreen
        if (CAUI.isFullscreenEnabled()) {
            this.fullscreenButton = new ControlButton({icon: 'expand', tooltip: 'Fullscreen', tooltipDirection: 'bottom'});


            this.controlsContainer.add(this.fullscreenButton);

            this.fullscreenButton.on('click touchstart', function () {
                CAUI.enterFullscreen(!this.fullscreen, this.el[0]);
                this.fullscreen = !this.fullscreen;

                this.fullscreenButton.setIcon(this.fullscreen ? 'compress' : 'expand');
                this.fullscreenButton.setTooltip(this.fullscreen ? 'Exit fullscreen' : 'Fullscreen');
                this.layout();
            }.bind(this));
        }

        // Audio
        this.audioButton = new ControlButton({icon: 'microphone-alt', tooltip: 'Read text', tooltipDirection: 'bottom'});


        this.controlsContainer.add(this.audioButton);

        this.audioButton.on('click touchstart', function () {
            if (this.isPlayingTts) 
                this.stopTextToSpeech();
             else 
                this.playTextToSpeech(this.container.find('.textLayer').text());
            


        }.bind(this));

        // Download
        this.downloadControl = new ControlButton({icon: 'download', tooltip: 'Download PDF', tooltipDirection: 'bottom'});


        this.controlsContainer.add(this.downloadControl);
        this.downloadControl.on('click touchstart', function () { // this.saveImage();
            window.open(this.options.url, '_blank', null, false);
        }.bind(this));

        this.initTextToSpeech();

        this.container = $('<div class="' + this.getComponentClass() + '_container"></div>');
        this.el.append(this.container);

        // this.doc = $('<div class="' + this.getComponentClass() + '_doc"></div>');
        // this.container.append(this.doc);

        const textId = CAUI.createId();

        this.doc = $('<div aria-describedby="' + textId + '" class="' + this.getComponentClass() + '_doc" data-pdf-url="' + this.options.url + '"></div>');
        this.container.append(this.doc);

        this.text = $('<div id="' + textId + '" class="' + this.getComponentClass() + '_text textLayer"></div>');
        this.container.append(this.text);
        // PDF
        pdfjsLib.GlobalWorkerOptions.workerSrc = this.options.workerSrc;
        pdfjsLib.getDocument({url: this.options.url, cMapUrl: '../../node_modules/pdfjs-dist/cmaps/', cMapPacked: true}).promise.then((pdf) => this.loadPage(pdf, 1), (e) => this.error(e));
    }

    toggleZoom() {
        this.zoommed = !this.zoommed;
        this.zoomInControl.el.attr('disabled', this.zoommed);
        this.zoomOutControl.el.attr('disabled', !this.zoommed);
        this.el.toggleClass(this.getComponentClass() + '--zoomed', this.zoommed);
    }

    loadPage(pdf, pageNumber) {
        pdf.getPage(pageNumber).then((page) => {

            const eventBus = new pdfjsViewer.EventBus();

            const pdfSinglePageViewer = new pdfjsViewer.PDFSinglePageViewer({
                container: this.container[0],
                eventBus: eventBus,
                renderer: 'canvas',
                textLayerMode: 0
            });
            pdfSinglePageViewer.setDocument(pdf);

            this.container.css({'position': 'static', 'background': 'transparent'});
            this.doc.find('svg, .canvasWrapper, .page').attr('width', '100%').width('100%').height('100%');

            page.getTextContent().then((textContent) => {
                
                const viewport = page.getViewport({scale: 1.0});

                // replace the canvas element with a static image render of the page from the media service
                $('.ca-ui-pdfview_doc[data-pdf-url="' + pdf._transport._params.url + '"] .page').addClass('tart').prepend('<img src="' + pdf._transport._params.url.replace('.pdf', '') + '?fm=jpg&w=1920&q=45" class="img-fluid">').find('canvas').remove();

                page.getAnnotations().then((e) => {

                    const annotations = e;
    
                    // using a timeout because couldn't get callbacks to work...
                    // should be updated to use callback of annotationlayerrendered or similar
                        $(annotations).each(function (index, annotation) {
    
                            // using the [data-pdf-url] param here to specify the exact annotation to adjust
                            // because there can be multiple PDFs open at once with annotations that share an annotation.id
                            // TODO: there has to be a better way, right? where we directly adjust the annotation itself
                            const annoEl = $('.ca-ui-pdfview_doc[data-pdf-url="' + pdf._transport._params.url + '"] [data-annotation-id="' + annotation.id + '"]');
                            
                            if (annotation.subtype != 'Link') { // we only want links, not notes
                                annoEl.remove();
                            } else { // adjust the position to be % based rather than px
                                const annoRect = annotation.rect;
                                annoEl.css({
                                    'transform': 'none',
                                    'transform-origin': 'unset',
                                    'left': annoRect[0] / viewport.width * 100 + '%',
                                    'top': (viewport.height - annoRect[3]) / viewport.height * 100 + '%',
                                    'width': (annoRect[2] - annoRect[0]) / viewport.width * 100 + '%',
                                    'height': (annoRect[3] - annoRect[1]) / viewport.height * 100 + '%'
                                }).children('a').attr('target', '_blank');
                            }
                        })
    
                })

                const textLayer = this.text[0];

                textLayer.style.left = this.doc[0].offsetLeft + 'px';
                textLayer.style.top = this.doc[0].offsetTop + 'px';
                textLayer.style.height = this.doc[0].offsetHeight + 'px';
                textLayer.style.width = this.doc[0].offsetWidth + 'px';

                pdfjsLib.renderTextLayer({textContent: textContent, container: textLayer, viewport: viewport, textDivs: []});
            });

            


            this.zoomInControl.show();
            this.zoomOutControl.show();
            this.downloadControl.show();
            this.zoomOutControl.show();
            this.audioButton.show();
            this.loadSpinner.hide();
            if (this.fullscreenButton) 
                this.fullscreenButton.show();
            


        });
    }

    error(e) {
        console.log(e);
    }

    playTextToSpeech(text) {
        this.loadSpinner.show();

        $.post('https://ver.caapp.com.au/api/text-to-speech/', {
            text: '<speak>' + text + '</speak>'
        }).done(function (data) {
            this.isPlayingTts = true;

            this.textToSpeechSource.attr('src', data);
            this.textToSpeechPlayer[0].load();
            this.textToSpeechPlayer[0].play();

            this.audioButton.setIcon('microphone-alt-slash');
            this.audioButton.setTooltip('Stop reading');
            this.loadSpinner.hide();
        }.bind(this)).fail(function (e) {
            console.log('fail');
            console.log(e);
        }).always(function () {});
    }

    saveImage() {}

    stopTextToSpeech() {
        if (this.textToSpeechPlayer) 
            this.textToSpeechPlayer[0].pause();
        


        this.isPlayingTts = false;
        this.audioButton.setIcon('microphone-alt');
        this.audioButton.setTooltip('Read text');
    }

    initTextToSpeech() {
        if (this.textToSpeechEnabled) 
            return;
        


        this.textToSpeechEnabled = true;

        this.textToSpeechPlayer = $('<audio class="ca-ui_texttospeech" controls="controls"></audio>');
        this.el.append(this.textToSpeechPlayer);

        this.textToSpeechPlayer.on('ended', function () {
            this.isPlayingTts = false;
            this.audioButton.setIcon('microphone-alt');
            this.audioButton.setTooltip('Read text');
        }.bind(this));

        this.textToSpeechPlayer.on('pause', function () {
            this.isPlayingTts = false;
            this.audioButton.setIcon('microphone-alt');
            this.audioButton.setTooltip('Read text');
        }.bind(this));

        this.textToSpeechSource = $('<source type="audio/mpeg" />');
        this.textToSpeechPlayer.append(this.textToSpeechSource);
    }
}(function ($) {
    $.fn.caPDFView = function (options) {
        return this.each(function () { // eslint-disable-next-line no-new
            new PDFView($.extend({
                element: this
            }, {}, options));
            return this;
        });
    };
})(jQuery);
